/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { arrivalsOrderItemSchema } from "./arrivalsOrderItemSchema.ts";

export const arrivalsOrderSchema = z.object({
	id: z.uuid(),
	number: z.int().min(-2147483648).max(2147483647).nullish(),
	drinksStatus: z.int().nullable(),
	foodStatus: z.int().nullable(),
	tab_name: z.string().nullish(),
	items: z.array(arrivalsOrderItemSchema),
});
